import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=584c8f4c&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchResults.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=584c8f4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c8f4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584c8f4c')) {
      api.createRecord('584c8f4c', component.options)
    } else {
      api.reload('584c8f4c', component.options)
    }
    module.hot.accept("./SearchResults.vue?vue&type=template&id=584c8f4c&scoped=true&", function () {
      api.rerender('584c8f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreSearch/components/SearchResults.vue"
export default component.exports